import { API_URL, API_KEY, TICKET_ENDPOINT } from '../configs/global';

export const FETCH_TICKET_INFO = 'FETCH_TICKET_INFO';

export const fetchTicketInfo = (number, email, code, cb) => {
  const url = `${API_URL}/${TICKET_ENDPOINT}/${number}?api_key=${API_KEY}`;

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    body: code ? "confirmation_token=" + encodeURIComponent(code) : "email=" + encodeURIComponent(email)
  };

  return (dispatch) => {
    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        dispatch({
          type: FETCH_TICKET_INFO,
          payload: response,
        });
        if (cb) {
          cb(response);
        }
      })
      .catch((error) => console.log(error));
  };
};

export const clearTicketInfo = () => (dispatch) => {
  dispatch({
    type: FETCH_TICKET_INFO,
    payload: {},
  });
};



// WEBPACK FOOTER //
// ./src/actions/TicketAction.js